/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import moment from "moment-timezone";

import { DataTableList } from '../../../components/DataTable/DataTableList';
import TopBar from '../../../components/TopBar';
import DeleteConfirmationPopup from '../../../components/DeleteConfirmationPopup';
import AddReview from '../../../components/Products/Review/AddReview';
import { getAllReview, createReview, updateReview, deleteReview, getReview } from '../../../api/reviewApi';

import Delete from "../../../assets/images/delete.svg";
import moreIcon from "../../../assets/images/more.svg";

import styles from '../page.module.css'

const ReviewList = () => {

    const ref = useRef();
    const tableActionRef = useRef();
    const popupRef = useRef()
    const addPopupRef = useRef()

    const [reviewList, setReviewList] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [showAddReviewPopup, setShowAddReviewPopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [editingReview, setEditingReview] = useState(null);
    const [formData, setFormData] = useState({
        name: null,
        productId: null,
        review: '',
        priceRating: '',
        valueRating: '',
        qualityRating: '',
        status: 'PENDING',
    })
    const [errorMessage, setErrorMessage] = useState({
        name: '',
        productId: '',
        review: '',
        priceRating: '',
        valueRating: '',
        qualityRating: '',
    })

    const [openPopupIndex, setOpenPopupIndex] = useState('');
    const [upDropdown, setUpDropdown] = useState();

    const actionPopup = (index) => {
        if (index === openPopupIndex) {
            setOpenPopupIndex(null);
        } else {
            setOpenPopupIndex(index);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
            if (addPopupRef.current && !addPopupRef.current.contains(event.target)) {
                setShowAddReviewPopup(false);
            }
            if (tableActionRef.current && !tableActionRef.current.contains(event.target)) {
                setOpenPopupIndex('');
            }
        };

        // Attach the event listener when the component mounts
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = reviewList?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = Math.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    useEffect(() => {
        if (reviewList?.length > 0) {
            calculateColumnWidths();
        }
    }, [reviewList]);

    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    useEffect(() => {
        if (reviewList?.length >= 3) {
            const lastThreeIds = reviewList.slice(-3).map(item => item.id);
            setUpDropdown(lastThreeIds);
        }
    }, [reviewList]);

    const fetchReviews = async () => {
        setIsLoadingData(true)
        try {
            const response = await getAllReview();
            if (response?.data?.result <= 0) {
                setIsLoadingData(false)
            }
            setReviewList(response?.data?.result || []);
            setTotalPage(response?.data?.totalPage || 0);
        } catch (error) {
            console.error('Failed to fetch reviews:', error);
            setReviewList([]);
        } finally {
            setIsLoadingData(false);
        }
    };

    useEffect(() => {
        fetchReviews();
    }, []);


    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(reviewList?.map((row) => row?.id));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleApprove = async (id) => {
        try {
            await updateReview(id, { status: 'APPROVED' });
            setReviewList(prev => prev.map(review => review.id === id ? { ...review, status: 'APPROVED' } : review));
        } catch (error) {
            console.error('Failed to approve review:', error);
        }
    };

    const handleDeny = async (id) => {
        try {
            await updateReview(id, { status: 'DENIED' });
            setReviewList(prev => prev.map(review => review.id === id ? { ...review, status: 'DENIED' } : review));
        } catch (error) {
            console.error('Failed to deny review:', error);
        }
    };

    const handlePending = async (id) => {
        try {
            await updateReview(id, { status: 'PENDING' });
            setReviewList(prev => prev.map(review => review.id === id ? { ...review, status: 'PENDING' } : review));
        } catch (error) {
            console.error('Failed to pending review:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errorMessage[name]) {
            setErrorMessage(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const roundToHalf = (num) => {
        return Math.round(num * 2) / 2;
    };

    const ratingAvg = (priceRating, valueRating, qualityRating) => {

        const avgRating = (Number(priceRating || 0) + Number(valueRating || 0) + Number(qualityRating || 0)) / 3;
        const finalRating = roundToHalf(avgRating);
        return finalRating;
    }


    const handleEdit = async (review) => {
        const response = await getReview(review.id)
        setEditingReview(review);
        setFormData({
            ...response?.data
        });
        setShowAddReviewPopup(true);
        setErrorMessage({});
        setOpenPopupIndex('');
    };

    const handleSubmit = async () => {
        const errors = {};

        if (!formData?.name?.trim()) errors.name = "Name is required";
        if (!formData?.productId) errors.productId = "Product is required";
        if (!formData?.review?.trim()) errors.review = "Description is required";
        if (!formData?.priceRating || Number(formData?.priceRating) < 1) errors.priceRating = "Price rating is required";
        if (!formData?.valueRating || Number(formData?.valueRating) < 1) errors.valueRating = "Value rating is required";
        if (!formData?.qualityRating || Number(formData?.qualityRating) < 1) errors.qualityRating = "Quality rating is required";

        if (Object.keys(errors).length > 0) {
            setErrorMessage(errors);
            return;
        }

        setIsLoading(true)

        const reviewData = {
            name: formData.name,
            productId: formData?.productId?.productId,
            review: formData.review,
            priceRating: Number(formData.priceRating),
            valueRating: Number(formData.valueRating),
            qualityRating: Number(formData.qualityRating),
            status: formData.status,
            averageRating: ratingAvg(Number(formData.priceRating), Number(formData?.valueRating), Number(formData?.qualityRating))
        };

        try {
            if (editingReview) {
                await updateReview(editingReview.id, reviewData);
            } else {
                const response = await createReview(reviewData);
                const newReview = response?.data?.result || [];
                setReviewList(newReview);
            }
            setIsLoading(false)
            fetchReviews(); // Refresh the list
        } catch (error) {
            setIsLoading(false)
            console.log('Failed to save review:', error);
        }

        setFormData({
            name: null,
            productId: null,
            review: '',
            priceRating: '',
            valueRating: '',
            qualityRating: '',
            status: 'PENDING',
        });
        setErrorMessage({});
        setShowAddReviewPopup(false);
        setEditingReview(null);
    };

    const columns = [
        {
            name: 'Product Title',
            selector: (row) => row?.product?.title,
            cell: (row) => <div className='editTitle'>{row.product?.title}</div>,
            sortable: true,
            minWidth: '200px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Status',
            selector: (row) => row?.status,
            cell: (row) => <div className={`editTitle ${row?.status === "APPROVED" ? styles.approveBtn : row?.status === "DENIED" ? styles.denyBtn : styles.pendingBtn}`}>{row?.status}</div>,
            sortable: true,
            width: '120px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "13px" },
        },
        {
            name: 'Rating',
            selector: (row) => ratingAvg(row?.priceRating, row?.valueRating, row?.qualityRating),
            cell: (row) => <div className='editTitle'>{ratingAvg(row?.priceRating, row?.valueRating, row?.qualityRating)}</div>,
            sortable: true,
            width: '100px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Created At',
            selector: (row) => row?.createdAt,
            cell: (row) => <div>{moment(row.createdAt).format('MMM DD, YYYY')}</div>,
            sortable: true,
            width: '150px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: "Actions",
            cell: (row) => {
                return (
                    <>
                        <div className='table-action' onClick={() => { actionPopup(row); }} ref={ref}>
                            <img src={moreIcon} alt="More" />
                        </div>
                        {
                            (row === openPopupIndex) &&
                            <>
                                <div
                                    className={`table-data-dropdown ${upDropdown?.includes(row?.id) ? "is-open" : ""
                                        }`}
                                    ref={tableActionRef}
                                >
                                    <ul>
                                        <li key={`approve-${row?.id}`}>
                                            <span onClick={() => handleApprove(row.id)}>
                                                <p>Approve</p>
                                            </span>
                                        </li>
                                        <li key={`deny-${row?.id}`}>
                                            <span onClick={() => handleDeny(row.id)}>
                                                <p>Deny</p>
                                            </span>
                                        </li>
                                        <li key={`pending-${row?.id}`}>
                                            <span onClick={() => handlePending(row.id)}>
                                                <p>Pending</p>
                                            </span>
                                        </li>
                                        <li key={`edit-${row?.id}`}>
                                            <span onClick={() => handleEdit(row)}>
                                                <p>Edit</p>
                                            </span>
                                        </li>
                                        <li key={`delete-${row?.id}`}>
                                            <span onClick={() => {
                                                setDeleteTarget({ type: "single", row });
                                                setShowDeletePopup(true);
                                            }}>
                                                <p>Delete</p>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </>
                        }
                    </>
                )
            },
            width: "80px"
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            if (deleteTarget.type === "single") {
                await deleteReview([deleteTarget.row.id]);
                setReviewList(prev => prev.filter(review => review.id !== deleteTarget.row.id));
            }

            if (deleteTarget.type === "multiple") {
                await deleteReview(deleteTarget.rows);
                setReviewList(prev => prev.filter(item => !deleteTarget.rows.includes(item.id)));
                setSelectedRows([]);
                setIsAllSelected(false);
                setToggleSelect(prev => !prev);
            }
        } catch (error) {
            console.error('Failed to delete review:', error);
        }

        setShowDeletePopup(false);
        setDeleteTarget(null);
    };

    return (
        <div className={`review-list ${styles.productList} ${reviewList?.length <= 10 && `${styles.productListHeight}`}`}>
            <TopBar />
            <div className={`${styles.productDatatableList}`}>
                <div className={`${styles.productHeader}`}>
                    <div className={`${styles.productHeading}`}>Reviews</div>
                    <div className={`${styles.actionButtonsDeleteAdd}`}>
                        <button className={`${styles.addBtn}`} onClick={() => {
                            setShowAddReviewPopup(true);
                            setErrorMessage({});
                            setEditingReview(null);
                            setFormData({
                                name: null,
                                productId: null,
                                review: '',
                                priceRating: '',
                                valueRating: '',
                                qualityRating: '',
                                status: 'PENDING',
                            })
                        }}>Add Review</button>
                        {selectedRows?.length > 0 && (
                            <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`reviewTable dataTable-list ${reviewList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={reviewList}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows.map((row) => row.id);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds.length === reviewList.length);
                        }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    />
                </div>
            </div>
            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={popupRef}
                title={deleteTarget?.type === "single" ? 'review' : selectedRows?.length === 1 ? 'review' : `reviews`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete this review?` : selectedRows?.length === 1 ? `Are you sure you want to delete review?` : `Are you sure you want to delete ${selectedRows?.length} reviews?`}
                confirmDelete={confirmDelete}
            />
            <AddReview
                showAddReviewPopup={showAddReviewPopup}
                popupRef={addPopupRef}
                errorMessage={errorMessage}
                formData={formData}
                handleChange={handleChange}
                setShowAddReviewPopup={setShowAddReviewPopup}
                handleSubmit={handleSubmit}
                styles={styles}
                editingReview={editingReview}
                isLoading={isLoading}
            />
        </div>
    )
}

export default ReviewList
